import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import Button from '~/components/Button'
import { getAgencyPrintout } from '@verzekeringapp-mono/shared/src/state/selectors/agency'
import { Images } from '@verzekeringapp-mono/shared/src/assets'
import LoginScreenWrapper from '~/components/screen_wrappers/login_screen_wrapper'
import useResourceAuthorization from '@verzekeringapp-mono/shared/src/hooks/use_resource_authorization'

const VerifyAddResourceAuthorizationScreen = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const email = urlParams.get('email')
  const relationNumber = urlParams.get('relation_number')
  const addResourceAuthToken = urlParams.get('add_resource_auth_token')
  const combiNumber = urlParams.get('combi_number')
  const [error, setError] = useState<string|null>(null)

  const  {
    handleSubmit,
    formState: { isValid }
  } = useForm({})

  const navigate = useNavigate()
  const { verifyAddResourceAuthorization } = useResourceAuthorization()

  const [isLoading, setIsLoading] = useState(false)

  const agencyPrintout = useAppSelector(getAgencyPrintout)

  const logo = useMemo(() => {
    if (agencyPrintout?.logoUrl) {
      return `${agencyPrintout.logoUrl}?${Date.now()}`
    }

    return Images.Logo
  }, [agencyPrintout])

  const onSubmit = async () => {
    if (!email || !relationNumber || !addResourceAuthToken) {
      alert('Velden niet gevonden')

      return
    }

    setIsLoading(true)
    try {
      const { message } = await verifyAddResourceAuthorization(email, Number.parseInt(relationNumber), addResourceAuthToken)

      window.alert(message)

      navigate('/overzicht')
    } catch (error) {
      setError((error as Error).message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <LoginScreenWrapper>
      <img
        src={logo}
        width={180}
        height={70}
        alt={'Logo van jouw verzekeringsadviseur'}
      />

      <h1 className='title-medium mt-8'>{'Bevestig je verzoek'}</h1>

      <h2 className='description my-8'>
        {`Je hebt een verzoek gedaan om je pakket met combipolisnummer ${combiNumber} toe te voegen aan je account met e-mailadres ${email}.`}
      </h2>

      {error && (
        <div className='my-4 rounded bg-status-danger-strong p-4 text-text-on-danger'>
          <span
            className='text-text-on-danger'
            dangerouslySetInnerHTML={{ __html: error}}
          />
        </div>
      )}

      <form onSubmit={handleSubmit(onSubmit)}>
        <Button
          className={`primary-btn w-full ${isValid ? '' : 'opacity-50'} my-5`}
          type='submit'
          isLoading={isLoading}
          disabled={!isValid}
        >
          {'Bevestig verzoek'}
        </Button>
      </form>

      <Button
        className='w-full my-2'
        onClick={() => navigate('/home')}
        variant='outline'
        type='button'
      >
      Terug
      </Button>
    </LoginScreenWrapper>
  )
}

export default VerifyAddResourceAuthorizationScreen
